import React, { useMemo } from "react";
import { Layers, Maximize2, Loader, CheckCircle, AlertTriangle, XCircle } from "lucide-react";
import { createBulkStyles, BULK_CSS } from "./bulkActions.styles";
import { fmt } from "../../Constant/EmployeeActions.bulk.i18n";

/** Floating card shown while the wizard is minimized (payroll-import style). */
export default function BulkProgressCard({ bulk, theme, language }) {
  const isRTL = language === "ar";
  const s = useMemo(() => createBulkStyles(theme, isRTL), [theme, isRTL]);
  const { bt, batch } = bulk;
  if (!bulk.minimized || !batch) return null;

  const total = batch.queuedRows || 0;
  const done = batch.processedCount || 0;
  const pct = total ? Math.min(100, Math.round((done / total) * 100)) : 100;
  const running = batch.status === "processing";
  const Icon = running ? Loader : batch.status === "completed" ? CheckCircle : batch.status === "failed" ? XCircle : AlertTriangle;
  const color = running ? s.k.accent : batch.status === "completed" ? "#10b981" : batch.status === "failed" ? "#ef4444" : "#f59e0b";
  const label = running ? bt.submittingTitle : batch.status === "completed" ? bt.doneTitle : batch.status === "failed" ? bt.failedTitle : bt.doneWithErrors;

  return (
    <div className="nxb-float" style={s.floatCard} role="status" aria-live="polite">
      <style>{BULK_CSS}</style>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ ...s.headerIcon, width: 38, height: 38, borderRadius: 11 }}><Layers size={18} /></div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 800, fontSize: 14 }}>{bt.floatingTitle}</div>
          <div style={{ fontSize: 12, color, display: "flex", alignItems: "center", gap: 6 }}>
            <Icon size={13} className={running ? "nxb-spin" : undefined} /> {label}
          </div>
        </div>
        <button
          type="button"
          className="nxb-btn"
          style={s.iconButton}
          aria-label={bt.open}
          title={bt.open}
          onClick={bulk.openWizard}
        >
          <Maximize2 size={16} />
        </button>
      </div>
      <div style={{ ...s.bar, marginTop: 12, height: 8 }}><div style={s.barFill(pct)} /></div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: s.k.muted, marginTop: 6 }}>
        <span>{fmt(bt.progress, { done, total })}</span>
        <span>{pct}%</span>
      </div>
    </div>
  );
}
